import { legacy_createStore as createStore } from 'redux'
import { applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger/src'
import { rootReducer } from './reducers/rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension'

export const configureStore = () => {
 
  if (process.env.NODE_ENV === 'production') {
    return createStore(rootReducer, applyMiddleware(thunk))
  }

  return createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk, logger)))
}